import { render, staticRenderFns } from "./LoadingTable.vue?vue&type=template&id=a39c4990&"
import script from "./LoadingTable.vue?vue&type=script&lang=ts&"
export * from "./LoadingTable.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingTable.vue?vue&type=style&index=0&id=a39c4990&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports